import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import SideMenu from './SideMenu/SideMenu';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const MainLayout = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [sideMenuOpen, setSideMenuOpen] = useState(true);
  const [title, setTitle] = useState('');
  const location = useLocation();

  useEffect(() => {
    const checkIfMobile = () => {
      const isMobileView = window.innerWidth < 768;
      setIsMobile(isMobileView);
      setSideMenuOpen(!isMobileView);
    };
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  const toggleSideMenu = () => setSideMenuOpen(prev => !prev);

  return (
    <div className="flex h-screen bg-surface-main overflow-hidden">
      {/* Toggle button */}
      <motion.button
        onClick={toggleSideMenu}
        whileTap={{ scale: 0.9 }}
        animate={{ left: sideMenuOpen ? '252px' : '16px' }}
        transition={{ type: 'spring', stiffness: 400, damping: 30 }}
        className="fixed z-50 top-[14px] bg-surface-card border border-white/[0.08] text-zinc-400 hover:text-zinc-100 hover:border-white/20 p-2 rounded-md transition-colors duration-200"
        aria-label="Toggle sidebar"
      >
        {sideMenuOpen ? <FaChevronLeft size={14} /> : <FaChevronRight size={14} />}
      </motion.button>

      <SideMenu
        isOpen={sideMenuOpen}
        isMobile={isMobile}
        toggleSideMenu={toggleSideMenu}
        setTitle={setTitle}
      />

      <div className={`flex flex-col flex-1 transition-all duration-300 overflow-hidden ${sideMenuOpen ? 'md:ml-64' : 'ml-0'}`}>
        <Header title={title} />
        <main className="flex-1 overflow-y-auto bg-surface-main" style={{ padding: '24px' }}>
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -6 }}
              transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
              style={{ height: '100%' }}
            >
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;
